<template>
  <div class="card">
    <div class="card-header">
      Vehicles
    </div>
    <div class="p-6">
      <div class="text-gray-500">
        Select the vehicles you would like to monitor with this rule.
      </div>
      <vehicle-toggle
        class="mt-6"
        :parent="form" 
        @toggle="methods.toggleVehicle" 
        @select-all="methods.toggleAllVehiclesOn" 
        @deselect-all="methods.toggleAllVehiclesOff" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VehiclesCard',

  props: {
    form: {
      type: Object,
      required: true
    },
    
    methods: {
      type: Object,
      required: true
    }
  }
}
</script>